import styles from './index.module.scss'
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import { useState, useEffect } from 'react';
import { Input } from 'antd';

const InputNumber = (props) => {
    const { min, max, currentNum, onChange } = props
    const [inputValue, setInputValue] = useState(currentNum);

    useEffect(() => {
        setInputValue(currentNum);
    }, [currentNum]);

    const handleInputChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setInputValue(value);
        }
    };

    const handleInputBlur = () => {
        let numValue = parseInt(inputValue, 10);

        if (isNaN(numValue)) {
            numValue = min;
        }

        if (numValue < min) {
            numValue = min;
        } else if (numValue > max) {
            numValue = max;
        }

        if (onChange) {
            onChange(numValue);
        }

        setInputValue(numValue);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleInputBlur();
        }
    };

    return (
        <p className={styles.mainImgNumber}>
            <MinusOutlined className={`${styles.numberIcon} ${currentNum <= min ? styles.disabled : ''}`} onClick={props.minusChange} />
            <Input
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onKeyDown={handleKeyDown}
                className={styles.inputNumber}
            />
            <PlusOutlined className={`${styles.numberIcon} ${currentNum >= max ? styles.disabled : ''}`} onClick={props.addChange} />
        </p>
    )
}

export default InputNumber